import { useAuthStore } from "~/stores/auth"
import { useCargoStore } from "~/stores/cargo"
import { useCarrierStore } from "~/stores/carrier"
import { useLocationStore } from "~/stores/location"
import { useShipperStore } from "~/stores/shipper"
import { useSmsStore } from "~/stores/sms"
import { useMessagesStore } from "~/stores/messages"
import { useTicketsStore } from "~/stores/tickets"
import { useDisputesStore } from "~/stores/disputes"
import { useTemplatesStore } from "~/stores/templates"
import { useAdminStore } from "~/stores/admin"
import { useVehicleTypesStore } from "~/stores/vehicleTypes"

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      authStore: useAuthStore(),
      cargoStore: useCargoStore(),
      carrierStore: useCarrierStore(),
      locationStore: useLocationStore(),
      shipperStore: useShipperStore(),
      smsStore: useSmsStore(),
      messagesStore: useMessagesStore(),
      ticketsStore: useTicketsStore(),
      disputesStore: useDisputesStore(),
      templatesStore: useTemplatesStore(),
      adminStore: useAdminStore(),
      vehicleTypesStore: useVehicleTypesStore(),
    },
  }
})
